import React, { useState, useEffect } from "react";
import styles from "./Products.module.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import { Carousel } from "primereact/carousel";
import { ProductService } from "./ProductServices";
import { Link } from "react-router-dom";
import axiosPrivate from "../../../hooks/axiosPrivate";
import LoaderContext from "../../../context/Loader/LoaderContext";
import { useContext } from "react";
import MinfertLogo from "../../../assets/images/logo.webp";
import HeaderWithLeaf from "../../HeaderWithLeaf";
import { useNavigate } from "react-router-dom";
import { removeFont16pxFromStyle } from "../../../utils/utils.function";

export default function Products() {
  const [products, setProducts] = useState([]);
  const { setLoaderCheck } = useContext(LoaderContext);
  const navigate = useNavigate();

  // const responsiveOptions = [
  //   {
  //     breakpoint: "1199px",
  //     numVisible: 2,
  //     numScroll: 1,
  //   },
  //   {
  //     breakpoint: "991px",
  //     numVisible: 2,
  //     numScroll: 1,
  //   },
  //   {
  //     breakpoint: "767px",
  //     numVisible: 1,
  //     numScroll: 1,
  //   },
  // ];

  const getSeverity = (product) => {
    switch (product.inventoryStatus) {
      case "INSTOCK":
        return "success";

      case "LOWSTOCK":
        return "warning";

      case "OUTOFSTOCK":
        return "danger";

      default:
        return null;
    }
  };

  const colors = ["#99D052", "#ED3237", "#F9C500"];

  useEffect(() => {
    setLoaderCheck(true);
    axiosPrivate
      .get("products")
      .then((products) => {
        setLoaderCheck(false);

        var products_list = [];
        let count = 0;
        count = count == 3 ? 0 : count;
        products.data?.data?.forEach((element) => {
          count = count + 1;
          let object = {
            id: element.id,
            brand: "Minfert",
            name: element?.name,
            types: element?.types, // Access "Type" directly from the API
            forms: element?.forms,
            name: element?.name,
            description: element?.short_description,
            slug: element?.slug,
            variant: element?.product_variants[0]?.variant,
            alt: element?.product_variants?.[0]?.varinat_iamges?.[0]?.alt,

            image:
              process.env.REACT_APP_COMMON_FILE_URL +
              "product-variants/" +
              element?.product_variants?.[0]?.varinat_iamges?.[0].image,
            link: "product-detail/" + element.slug,
            background: colors[count % colors.length],
          };
          products_list.push(object);
        });

        setProducts(products_list);
      })
      .catch((err) => {
        setLoaderCheck(false);
        console.log(err);
      });
  }, []);

  const responsiveOptions = [
    {
      breakpoint: "1024px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "768px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "560px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  const productTemplate = (product) => {
    return (
      <Link to={`/${product.link}`}>
        <div
          className={styles.productContainer}
          style={{ backgroundColor: product.background }}
        >
          {/* <div className={styles.logoDiv}> */}
          {/* <img src={MinfertLogo} alt="Minfert Logo" className={styles.logoImg} style={{  backgroundColor: 'white', */}
          {/* width: '356px',  */}
          {/* marginTop: '9px',  */}
          {/* }} */}
          {/* </div> */}
          <div className={styles.content}>
            <img
              src={product.image}
              alt={product?.alt}
              className={styles.productImg}
              loading="lazy"
            />
          </div>
          <div className={styles.productDetails}>
            <div className={styles.productName}>
              <h4 className="text-left">{product.name}</h4>
            </div>
            <div className={styles.productDescription}>
              {/* <div className={styles.descriptionLine}>
                <span>Types:</span> {product.types}
              </div>
              <div className={styles.descriptionLine}>
                <span>About Product:</span> {product.forms}
              </div>
              <div className={styles.descriptionLine}>
                <span>Packs:</span> {product.variant}
              </div> */}
              <p>{product.forms}</p>
              <div
                style={{ marginTop: "20px", fontSize: "14px" }}
                dangerouslySetInnerHTML={{
                  __html: removeFont16pxFromStyle(product?.short_description),
                }}
              />
            </div>
            {/* <div className={styles.productLink}> */}
            {/* <Link style={{color:"white"}} to={product.link}>Shop Now</Link> */}
            {/* </div> */}
          </div>
        </div>
      </Link>
    );
  };

  return (
    <div
      className={`container custom-carousel section-p-spacing-top section-p-spacing-bottom`}
    >
      <div className={styles.headingContainer}>
        <HeaderWithLeaf text={"Our Products"} />
        <p className={styles.mainContent}>
          Natural Products To Enhance Plant Growth.
        </p>
        <button
          style={{
            background: "var(--green)",
            color: "white",
            padding: "8px 16px",
            border: "none",
            cursor: "pointer",
            marginBottom: "1.5rem",
          }}
          onClick={() => {
            navigate("/urban-gardens");
          }}
        >
          View All
        </button>
      </div>
      <div className={`${styles.card} ${styles.customCarousel}`}>
        <Carousel
          value={products}
          numScroll={1}
          numVisible={3}
          responsiveOptions={responsiveOptions}
          itemTemplate={productTemplate}
        // autoplayInterval={1000}
        />
      </div>
    </div>
  );
}
